<template>
  <base-section id="news" space="72">
    <v-container>
      <a href="/blog.atom" target="_blank" rel="noopener noreferrer" type="application/atom+xml"
        ><v-icon style="color: orangered">mdi-rss-box</v-icon></a
      >
      <v-row justify="center">
        <v-col cols="12" md="12">
          <news-card-preview
            v-for="(article, i) in articles"
            is-preview
            :key="i"
            :divider="i + 1 < articles.length"
            v-bind:is-read="readArticles.find(ra => ra === article.slug)"
            class="mb-12"
            v-bind="article"
          />
        </v-col>

        <!-- <v-col
          cols="12"
          md="3"
        >
          <news-search />

          <news-categories />

          <news-archives />

          <news-tags />
        </v-col> -->
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
const articles = require("../../blog-articles.json");

export default {
  name: "SectionBlog",

  components: {
    // NewsArchives: () => import("@/components/news/Archives"),
    NewsCardPreview: () => import("@/components/news/CardPreview")
    // NewsCategories: () => import("@/components/news/Categories"),
    // NewsSearch: () => import("@/components/news/Search"),
    // NewsTags: () => import("@/components/news/Tags")
  },

  data: () => ({
    readArticles: []
  }),

  computed: {
    articles() {
      return articles
        ? articles.filter(article => article.published)
        : undefined;
    }
  },

  created() {
    this.readArticles = JSON.parse(
      localStorage.getItem("read-articles") || "[]"
    );
  }
};
</script>
